import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const translations = {
  hindi: {
    // Header
    home: 'मुख्य पृष्ठ',
properties: 'संपत्तियाँ',
services: 'सेवाएँ',
login: 'लॉगिन',
logout: 'लॉगआउट',

adminDashboard: 'एडमिन डैशबोर्ड',
loginToAdmin: 'एडमिन लॉगिन',

// Home Page
welcomeTitle: 'बिसौली में आपका स्वागत है',
welcomeSubtitle: 'अपने सपनों का घर खोजें या अपने आसपास के भरोसेमंद पेशेवरों से जुड़ें।',

featuredProperties: '🏠 चुनिंदा संपत्तियाँ',
propertiesSubtitle: 'आपके क्षेत्र में सावधानी से चुनी गई किराये और बिक्री की संपत्तियाँ',
viewAllProperties: 'सभी संपत्तियाँ देखें',
exploreAll: 'सभी देखें',
browseProperties: 'उन्नत फ़िल्टर के साथ सभी संपत्तियाँ ब्राउज़ करें',

featuredExperts: '⭐ चुनिंदा विशेषज्ञ',
expertsSubtitle: 'घर से जुड़ी हर ज़रूरत के लिए हमारे विश्वसनीय और उच्च-रेटिंग प्राप्त पेशेवर',
browseExperts: 'सभी पेशेवरों को ब्राउज़ करें',

cta: '📢 क्या आप अपनी संपत्ति या सेवाएँ सूचीबद्ध करना चाहते हैं?',
ctaText: 'संपत्ति मालिकों और पेशेवरों के हमारे बढ़ते समुदाय से जुड़ें। आज ही अपनी सूची जोड़ें और हज़ारों संभावित ग्राहकों तक पहुँचें।',

listProperty: 'संपत्ति सूचीबद्ध करें',
listPropertyDesc: 'अपनी संपत्ति किराये पर दें, बेचें या इच्छुक खरीदारों व किरायेदारों तक पहुँचाएँ',
addProperty: 'नई संपत्ति जोड़ें',

becomeExpert: 'विशेषज्ञ बनें',
becomeExpertDesc: 'अपनी सेवाएँ प्रदान करें और ग्राहकों से सीधे जुड़ें',
addExpertProfile: 'विशेषज्ञ प्रोफ़ाइल जोड़ें',

viewAllExperts: 'सभी विशेषज्ञ देखें',

    
    // Property Details
    propertyDetails: 'संपत्ति विवरण',
    images: '📸 छवियां',
    description: 'विवरण',
    propertyFeatures: 'संपत्ति की विशेषताएं',
    bedrooms: 'बेडरूम',
    bathrooms: 'बाथरूम',
    area: 'क्षेत्र',
    category: 'श्रेणी',
    ownerInfo: '👤 मालिक की जानकारी',
    name: 'नाम',
    phone: 'फोन',
    email: 'ईमेल',
    propertyId: 'संपत्ति आईडी',
    close: 'बंद करें',
    callOwner: 'मालिक को कॉल करें',
    shareWhatsApp: 'व्हाट्सएप पर साझा करें',
    shareEmail: 'ईमेल के माध्यम से साझा करें',
    shareDetails: 'संपत्ति विवरण साझा करें',
    moreOptions: 'अधिक विकल्प',
    sharedWhatsApp: 'व्हाट्सएप पर साझा किया गया!',
    sharedEmail: 'ईमेल क्लाइंट खोल रहे हैं...',
    copiedClipboard: 'संपत्ति विवरण क्लिपबोर्ड में कॉपी किए गए!',
    checkProperty: 'इस संपत्ति को देखें',
    beds: 'बिस्तर',
    baths: 'नहाने का कमरा',
    owner: 'मालिक',
    notAvailable: 'उपलब्ध नहीं',
  },
  english: {
    // Header
    home: 'Home',
    properties: 'Properties',
    services: 'Services',
    logout: 'Logout',
    login: 'Login',
    adminDashboard: 'Admin Dashboard',
    loginToAdmin: 'Login to Admin',
    
    // Home Page
    welcomeTitle: 'Welcome to अपना बिसौली',
    welcomeSubtitle: 'Discover your perfect home or find trusted professionals in your area',
    featuredProperties: '🏠 Featured Properties',
    propertiesSubtitle: 'Hand-picked rental listings available in your area',
    viewAllProperties: 'View All Properties',
    exploreAll: 'Explore All',
    browseProperties: 'Browse all properties with advanced filters',
    featuredExperts: '⭐ Featured Experts',
    expertsSubtitle: 'Meet our top-rated professionals ready to help with your home needs',
    browseExperts: 'Browse all professional experts',
    cta: '📢 Have a Property or Service to Share?',
    ctaText: 'Join our growing community of property owners and professionals. Submit your listing today and reach thousands of potential customers!',
    listProperty: 'List Your Property',
    listPropertyDesc: 'Rent, sell, or showcase your property to interested buyers and renters',
    addProperty: 'Add Property',
    becomeExpert: 'Become an Expert',
    becomeExpertDesc: 'Offer your services and connect with customers looking for professionals',
    addExpertProfile: 'Add Expert Profile',
    viewAllExperts: 'View All Experts',
    
    // Property Details
    propertyDetails: 'Property Details',
    images: '📸 Images',
    description: 'Description',
    propertyFeatures: 'Property Features',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    area: 'Area',
    category: 'Category',
    ownerInfo: '👤 Owner Information',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    propertyId: 'Property ID',
    close: 'Close',
    callOwner: 'Call Owner',
    shareWhatsApp: 'Share on WhatsApp',
    shareEmail: 'Share via Email',
    shareDetails: 'Share Property Details',
    moreOptions: 'More Options',
    sharedWhatsApp: 'Shared on WhatsApp!',
    sharedEmail: 'Opening email client...',
    copiedClipboard: 'Property details copied to clipboard!',
    checkProperty: 'Check out this property',
    beds: 'Beds',
    baths: 'Baths',
    owner: 'Owner',
    notAvailable: 'Not Available',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('hindi');

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('appLanguage', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};